import React from "react";
import { Navigate } from "react-router-dom";
import { useAuthenticator } from "@aws-amplify/ui-react";

export const ProtectedRoute = ({ children }) => {
  const { authStatus } = useAuthenticator((context) => [context.user]);

  if (authStatus === "unauthenticated") {
    return <Navigate to="/login" />;
  }
  
  return children;
};
